import SloganBg from '@/assets/website/slogan_bg.svg';
import Slogan from '@/assets/website/slogan.png';
export default function HomeBanner() {
  return (
    <div
      className="relative h-[560px] w-full"
      style={{
        backgroundImage: `url(${SloganBg})`,
        backgroundPosition: 'center 60%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] text-sm">
        <img className="w-full items-center text-center" src={Slogan}></img>
        <p className="mt-3 text-center text-[16px] leading-[24px] text-[#4E4E4E]">
          {/* Vitae3 is your universal on-chain profile, using non-transferable NFT
          to make your ID, data, and activity traceable and permanently
          preserved. */}
          Vitae3 codifies the off-chain reputation as the SBT, which could used
          to incentive members, play as the non-financialized governance,
          permissions and profile content.
        </p>
      </div>
    </div>
  );
}
